
<template>
  <div class="lf marketing ml">
    
    <div class="marketing-wrap">
      <div class="marketing-inner">
        <div id="myChartAge" style="width:100%;height:100%;"></div>
      </div>
    </div>
    <title-h3 :titlemsg="titlemsg"></title-h3>
  </div>

</template>

<script>
  import * as echarts from 'echarts';

  import title from '../title';
  export default{
    name:'visitorAge',
    data(){
      return{
        titlemsg:'商品数据'
      }
    },
    mounted(){
      this.drawLine();
    },
    methods: {
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChartAge'))
        // 绘制图表
        // 指定图表的配置项和数据

        // prettier-ignore
        let dataAxis = ['促销商品', '拼团商品', '助力商品'];
        // prettier-ignore
        let data = [220, 182, 234];
        let yMax = 500;
        let dataShadow = [];
        for (let i = 0; i < data.length; i++) {
          dataShadow.push(yMax);
        }
        var option = {
          // title: {
          //   text: '特性示例：渐变色 阴影 点击缩放',
          //   subtext: 'Feature Sample: Gradient Color, Shadow, Click Zoom'
          // },
          xAxis: {
            data: dataAxis,
            axisLabel: {
              inside: true,
              color: '#fff'
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle:{
                color:'#637eaf'
              }
            },
            z: 10
          },
          yAxis: {
            axisLine: {
              show: true,
              lineStyle:{
                color:'#fff'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#999'
            }
          },
          dataZoom: [
            {
              type: 'inside'
            }
          ],
          series: [
            {
              type: 'bar',
              showBackground: true,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#83bff6' },
                  { offset: 0.5, color: '#188df0' },
                  { offset: 1, color: '#188df0' }
                ])
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#2378f7' },
                    { offset: 0.7, color: '#2378f7' },
                    { offset: 1, color: '#83bff6' }
                  ])
                }
              },
              data: data
            }
          ]
        };
        // Enable data zoom when user click bar.
        const zoomSize = 4;
        myChart.on('click', function (params) {
          console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
          myChart.dispatchAction({
            type: 'dataZoom',
            startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
            endValue:
              dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)]
          });
        });

        option && myChart.setOption(option);

        // var dataAxis = ['18岁以下', '19-29', '30-39', '40-49', '50岁及以上'];
        // var data = [2000, 1802, 1910, 2340, 2900];
        // var yMax = '100%';
        // var dataShadow = [];

        // for (var i = 0; i < data.length; i++) {
        //   dataShadow.push(yMax);
        // }

        // var option =  {
        //   grid:{
        //     left:'12%',
        //     top:'10%',
        //     bottom:'12%',
        //     right:'4%'
        //   },
        //   xAxis: {
        //     data: dataAxis,
        //     axisLabel: {
        //       textStyle: {
        //         color: '#fff'
        //       }
        //     },
        //     axisTick: {
        //       show: false
        //     },
        //     axisLine: {
        //       show: true,
        //       lineStyle:{
        //         color:'#637eaf'
        //       }
        //     },
        //     z: 10
        //   },
        //   yAxis: [
        //     {
        //       type: 'value',
        //       splitLine:{show: false},//去除网格线
        //       axisLine: {
        //         show: true,
        //         lineStyle:{
        //           color:'#637eaf'
        //         }
        //       },
        //       axisLabel: {
        //         show: true,
        //         interval: 'auto',
        //         formatter: '{value} %',
        //         textStyle: {
        //           color: '#fff'
        //         }
        //       },
        //       show: true
        //     }
        //   ],
        //   series: [{
        //     data:data,
        //     type: 'bar',
        //     barWidth : 30,
        //     itemStyle: {
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         { offset: 0, color: '#83bff6' },
        //         { offset: 0.5, color: '#188df0' },
        //         { offset: 1, color: '#188df0' }
        //       ])
        //     },

        //   }]};

        // // 使用刚指定的配置项和数据显示图表。
        // myChart.setOption(option);
      }
    },
    components:{
      'title-h3':title
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/marketing/visitorAge.vue